import Dropzone from "react-dropzone";
import PropTypes from "prop-types";
import React from "react";
import {MAX_IMAGE_SIZE} from "../../../../../state/detail/const";
import ImageVersionGallery from "../ImageVersionGallery";
import Row from "../../../../../../bootstrap/component/Row";
import Column from "../../../../../../bootstrap/component/Column";
import DropdownContainer from "../Dropdown/DropdownContainer";

const style = {
    width: '100%',
    height: '200px',
    borderWidth: '2px',
    borderColor: 'rgb(102, 102, 102)',
    borderStyle: 'dashed',
    borderRadius: '5px',
    padding: '35px',
    textAlign: 'center',
    cursor: 'pointer',
    marginTop: '60px',
}

const findStartIndex = (imageVersionList, selectedImageVersions, preCheckinPhotoIndex) => {
    let startIndex = imageVersionList !== undefined ? imageVersionList.length - 1 : null
    if (selectedImageVersions !== null) {
        selectedImageVersions.find(function (selectedImageVersion) {
            if (selectedImageVersion.preCheckinPhotoIndex === preCheckinPhotoIndex) {
                startIndex = selectedImageVersion.imageVersionIndexInGallery
                return true
            }
            return false
        })
    }

    return startIndex
}

const PreCheckinPhoto = ({
                             image,
                             imageVersionList,
                             customerId,
                             uploadCustomerImage,
                             rotateCustomerImage,
                             setImageTypeMetaData,
                             setSelectedImageVersions,
                             selectedImageVersions,
                             preCheckinPhotoIndex,
                         }) => {

    const handleOnSlide = (index) => {
        setSelectedImageVersions(preCheckinPhotoIndex, index);
    }

    let startIndex = findStartIndex(imageVersionList, selectedImageVersions, preCheckinPhotoIndex);

    return (
        <Row top="M" className="pre-checkin-photo-row">
            <Column size={8}>
                <h2>{image.title}</h2>
                {imageVersionList ?
                    <ImageVersionGallery
                        image={image}
                        imageVersionList={imageVersionList}
                        customerId={customerId}
                        setImageTypeMetaData={setImageTypeMetaData}
                        rotateCustomerImage={rotateCustomerImage}
                        handleOnSlide={handleOnSlide}
                        startIndex={startIndex}
                    /> : ""}
            </Column>
            <Column size={4}>
                <Dropzone
                    multiple={false}
                    accept="image/*"
                    maxSize={MAX_IMAGE_SIZE}
                    style={style}
                    disablePreview={true}
                    onDrop={fileList => {
                        uploadCustomerImage(fileList, image.name, customerId)
                    }}
                >
                    <p>Click to upload a picture</p>
                </Dropzone>
                {imageVersionList !== undefined && imageVersionList !== null ?
                    <DropdownContainer
                        preCheckinPhotoIndex={preCheckinPhotoIndex}
                        startIndex={startIndex}
                        imageVersionList={imageVersionList}
                    /> : ""}
            </Column>
        </Row>
    )
};

PreCheckinPhoto.propTypes = {
    image: PropTypes.object,
    imageVersionList: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]),
    customerId: PropTypes.string,
    uploadCustomerImage: PropTypes.func.isRequired,
    rotateCustomerImage: PropTypes.func.isRequired,
    setImageTypeMetaData: PropTypes.func.isRequired,
    setSelectedImageVersions: PropTypes.func.isRequired,
    selectedImageVersions: PropTypes.array,
    preCheckinPhotoIndex: PropTypes.number,
}

export default PreCheckinPhoto



// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/customerPreCheckinImageWidget/components/PreCheckinPhoto/PreCheckinPhoto.js